// Revision-aware localStorage dismissal store for one-time banners.
//
// Anonymous (logged-out) users have no user_id, so their one-time dismissals
// cannot be persisted server-side. We persist them in localStorage keyed by
// banner id, storing the banner REVISION (its `updated_at`) that was dismissed.
// A dismissal only suppresses the banner while the stored revision matches the
// current one — so an edited banner (new revision) re-shows, matching the
// server-side `dismissed_at >= updated_at` rule for authenticated users.
//
// All access is try/catch-guarded (incognito / disabled storage / quota).

const KEY_PREFIX = 'dw-banner-dismissed:'

function key(bannerId: string): string {
  return `${KEY_PREFIX}${bannerId}`
}

/** True when this banner+revision was already dismissed on this device. */
export function isDismissed(bannerId: string, revision: string): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(key(bannerId)) === revision
  } catch {
    return false
  }
}

/** Persist a one-time dismissal for this banner+revision. */
export function persistDismissed(bannerId: string, revision: string): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(key(bannerId), revision)
  } catch {
    // storage blocked — the in-memory hide still applies for this pageview.
  }
}
